// Sprint 8 — Flex4Success Rebrand: zentrale Brand-Konstanten.
// Alle Frontend-Komponenten lesen Name/Domain/E-Mail über diese Datei,
// damit ein zukünftiger Rebrand nur Environment-Variablen ändern muss.
//
// Reihenfolge:
//   1. Build-time ENV (Create-React-App liefert env-vars unter REACT_APP_*)
//   2. Default-Fallback = Flex4Success (Sprint 8 Launch-Marke)

const env = (typeof process !== "undefined" && process.env) || {};

export const BRAND = {
  name: env.REACT_APP_BRAND_NAME || "Flex4Success",
  // Tagline darf optional via ENV überschrieben werden (z.B. für Kampagnen)
  tagline: env.REACT_APP_BRAND_TAGLINE || "Dein Kommunikations-Coach",
  domain: env.REACT_APP_BRAND_DOMAIN || "flex4success.effektiv-kommunizieren.de",
  email: env.REACT_APP_BRAND_EMAIL || "hallo@effektiv-kommunizieren.de",
  url: (() => {
    const d = env.REACT_APP_BRAND_DOMAIN || "flex4success.effektiv-kommunizieren.de";
    return `https://${d}`;
  })(),
  // Lowercase-Variante (oft in Logos verwendet)
  nameLowercase: (env.REACT_APP_BRAND_NAME || "Flex4Success").toLowerCase(),
};

export default BRAND;
